export default __webpack_public_path__ + "static/media/tsql.7e3c2025.svg";